import { render, staticRenderFns } from "./QuickCreateMenu.vue?vue&type=template&id=860b4afc&scoped=true&"
import script from "./QuickCreateMenu.vue?vue&type=script&lang=ts&"
export * from "./QuickCreateMenu.vue?vue&type=script&lang=ts&"
import style0 from "./QuickCreateMenu.vue?vue&type=style&index=0&id=860b4afc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860b4afc",
  null
  
)

export default component.exports